<template>
    <div>
        <el-row :gutter="20">
            <el-card>
                <div slot="header" class="clearfix" style="margin-top:-5px;margin-bottom:-5px">
                    <el-row>
                        <el-col :span="6" style="font-size:14px;line-height:26px;">
                            <div style="text-align:center">
                                    <b style="font-size:14px;">已选 <span style="color:#F56C6C"> {{num}} </span> 个任务，
                                    共计 <span style="color:#F56C6C"> {{orderNum}} </span> 单
                                        
                                    </b>
                                    <!-- <el-link type="primary" @click="next" style="margin-top:-4px">人工</el-link>
                                    <el-link type="primary" @click="nextAuto" style="margin-top:-4px;margin-left:10px">半自动</el-link> -->
                                    <el-link type="primary" @click="fullyAuto(0)" style="margin-top:-4px;margin-left:10px">自动均匀</el-link>
                                    <el-link type="primary" @click="fullyAuto(1)" style="margin-top:-4px;margin-left:10px">自动尽力</el-link>
                                    <el-divider direction="vertical"></el-divider>
                                </div>
                        </el-col>
                        <el-col :span="12" style="font-size:14px;line-height:26px">
                            <el-col style="" :span="6">
                                
                                <b>总单数：<el-tag size="mini" >{{data.Num}}</el-tag> </b>
                            </el-col >
                            <el-col :span="6">
                                <b>已派单：<el-tag size="mini" type="success">{{data.OkNum}}</el-tag> </b>
                            </el-col >
                            <el-col :span="6">
                                <b>未派单：<el-tag size="mini" type="danger">{{data.LaveNum}}</el-tag> </b>
                            </el-col>
                            <el-col :span="6">
                                <b>排队刷手：<el-tag size="mini" type="danger">{{data.SwipeNum}}</el-tag> </b>
                            </el-col>
                        </el-col>
                        <el-col :span="6">
                            <el-progress :text-inside="true" :stroke-width="26" :percentage="data.Process"></el-progress>
                        </el-col>
                    </el-row>
                </div>
            <el-row>
            <el-col :span="10" style="border-right:2px dashed #DCDFE6;;" >
                <el-table
                    :height="bodyHeight-80"
                    v-loading="isLoading"
                    :data="tableData"
                     @selection-change="handleSelectionChange"
                    style="width: 100%">
                        <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        width="160"
                            label="任务编号">
                            <template slot-scope="scope">
                                <el-link target="_blank" @click="taskGetDetail(scope.row)"  type="primary">{{scope.row.Code}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="@/assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="@/assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==6" >
                                    <div style="margin-left:5px;width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="@/assets/dy.jpg">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="@/assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120px"
                            label="费用明细">
                            <template slot-scope="scope">
                                <el-tooltip   class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p>预计商品金额：￥ {{scope.row.ExpectedPrice.toFixed(2)}}</p>
                                        <p>预计佣金：￥ {{scope.row.ExpectedCommission.toFixed(2)}}</p>
                                        <p>实际商品金额：{{scope.row.ActualPrice==0?'暂无':'￥ '+scope.row.ActualPrice.toFixed(2)}}</p>
                                        <p>实际佣金：{{scope.row.ActualCommission==0?'暂无':'￥ '+scope.row.ActualCommission.toFixed(2)}}</p>
                                    </div>
                                     <el-link  icon="el-icon-money"  type="primary">￥{{scope.row.Total.toFixed(2)}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120"
                            label="期望完成">
                            <template slot-scope="scope">
                                <el-link @click="setExpectedOverTime(scope.row)" icon="el-icon-date" type="primary">{{scope.row.ExpectedOverTime.toString().split(' ')[0]}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="70"
                            label="总单数">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="dark" type="info" v-if="scope.row.OrderCount==0">暂无</el-tag>
                                <el-tag size="mini" effect="dark" v-else>{{scope.row.OrderCount}}</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
            </el-col>
            <el-col :span="14" >
                <el-table
                    :height="bodyHeight-80"
                    v-loading="isLoading"
                    :data="processTableData"
                    style="width: 100%">
                        <el-table-column
                        width="160"
                            label="任务编号">
                            <template slot-scope="scope">
                                <el-link target="_blank"  type="primary">{{scope.row.TaskCode}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="230"
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="@/assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="@/assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="@/assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="60"
                            label="类型">
                            <template slot-scope="scope">
                                 <el-tag style="cursor:pointer" size="mini" @click="changeType(scope.row)" type="" >{{scope.row.AutoType==0?'均匀':'尽力'}}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column
                        width="100"
                            label="总单数">
                            <template slot-scope="scope">
                                 <el-tag size="mini" type="" effect="dark">{{scope.row.Num}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="100"
                            label="已完成">
                            <template slot-scope="scope">
                                 <el-tag size="mini" :type="scope.row.Num>scope.row.OkNum?'danger':'success'" effect="dark">{{scope.row.OkNum}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="180"
                            label="下次放单时间">
                            <template slot-scope="scope">
                                <el-link @click="setNextTime(scope.row)" icon="el-icon-date" type="primary">{{scope.row.NextTime}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="180"
                            label="最后放单时间">
                            <template slot-scope="scope">
                                <el-link @click="setEndTime(scope.row)" icon="el-icon-date" type="primary">{{scope.row.EndTime}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="50"
                            label="操作">
                            <template slot-scope="scope">
                                    <el-tooltip class="item"  v-if="!scope.row.IsPause" effect="dark" content="暂停" placement="bottom">
                                        <el-button @click="changeIsPause(scope.row)" size="mini" type="danger" icon="el-icon-video-pause" circle></el-button>
                                    </el-tooltip>
                                <el-tooltip class="item"  v-else effect="dark" content="继续" placement="bottom">
                                        <el-button @click="changeIsPause(scope.row)" size="mini" type="success" icon="el-icon-video-play" circle></el-button>
                                    </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
            </el-col>
            </el-row>
             </el-card>
        </el-row>
        <el-dialog
        title="修改时间"
        :visible.sync="setEndTimeVisible"
        width="300px"
        center>
                  <el-time-picker
                  :editable="false"
                  :clearable="false"
    v-model="endTime"
    :picker-options="{
      selectableRange: '12:00:00 - 21:00:00'
    }"
    placeholder="请选择时间">
  </el-time-picker>
            <span slot="footer" class="dialog-footer">
                <el-button @click="setEndTimeVisible = false">取 消</el-button>
                <el-button type="primary" @click="setEndTimeAction">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import {taskGroupChangeType, taskGroupSetEndTime, taskGroupChangeIsPause, taskGroupGetArrangement, taskGroupGetProcess,taskGroupAssignAuto, managerGetSel,taskBatchAssign,taskBatchGetExpected,commissionGetAll,taskGroupFullyAuto} from '@/request.js'

export default {
    components: {
    },
    data(){
        return {
            bodyHeight:0,
            isLoading:false,
            tableData:[],
            task:{},
            details:[],
            multipleSelection:[],
            num:0,
            orderNum:0,
            dialogVisible:false,
            managerList: [],
            checkList:[],
            yifenpei:0,
            data:{},
            processTableData:[],
            timer:{},
            setEndTimeVisible:false,
            setRow:{},
            endTime:{},
            setType:0,
        }
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    created(){
        commissionGetAll({},(res)=>{
            this.commissions=res.Result;
        });
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){

        taskGroupGetProcess({},(res)=>{
            this.data=res.Result;
        })
        this.timer= setInterval(() => {
            taskGroupGetProcess({},(res)=>{
                this.data=res.Result;
            })
        }, 1000);
        
        this.queryTaskGroupGetArrangement();
        managerGetSel({},(res)=>{
            this.managerList=res.Result;
            this.managerList.forEach( x=>{
                this.checkList.push({
                    managerId:x.Id,
                    isCheck:false,
                    num:0
                });
            })
        });
    },
    methods: {
        changeType(scope){
            this.$confirm('确定更改放单类型为'+(scope.AutoType==0?'尽力':'均匀')+'吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                var newType=scope.AutoType==0?1:0;
                taskGroupChangeType({taskId:scope.Id,type:newType},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.AutoType=newType;
                        }else{
                            this.$message.error(res.Message);
                        }
                })
            }).catch(() => {
      
            });
        },
        setEndTimeAction(){
            taskGroupSetEndTime({taskId:this.setRow.Id,endTime:this.endTime,setType:this.setType},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.setEndTimeVisible=false;
                        this.queryTaskGroupGetArrangement();
                    }else{
                        this.$message.error(res.Message);
                    }
            });
        },
        setEndTime(scope){
            this.setType=2;
            this.setRow=scope;
            this.setEndTimeVisible=true;
        },
        setNextTime(scope){
            this.setType=1;
            this.setRow=scope;
            this.setEndTimeVisible=true;
        },
        changeIsPause(scope){
            this.$confirm('确定'+(scope.IsPause?'继续':'暂停')+'任务吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                taskGroupChangeIsPause({taskId:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.IsPause=!scope.IsPause;
                        }else{
                            this.$message.error(res.Message);
                        }
                })
            }).catch(() => {
      
            });

        },
        queryTaskGroupGetArrangement(){
            taskGroupGetArrangement({},(res)=>{
                this.processTableData=res.Result;
            });
        },
        fullyAuto(type){
            var msg=type==0?"确定将所选任务设置为自动均匀放单吗?":"确定将所选任务设置为自动尽力放单吗?";
            this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                let arr=[];
                this.multipleSelection.forEach(x=>{
                    arr.push(x.Id);
                });
                taskGroupFullyAuto({taskId:JSON.stringify(arr),type:type},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '分配成功',
                            type: 'success'
                        });
                        this.query();
                        this.queryTaskGroupGetArrangement();
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
      
            });
        },
        nextAuto(){
            if(this.multipleSelection.length>0){
                this.$prompt('请输入任务数量', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^[1-9]\d*$/,
                inputErrorMessage: '请输入正整数'
                }).then(({ value }) => {
                    let arr=[];
                    this.multipleSelection.forEach(x=>{
                        arr.push(x.Id);
                    });
                    taskGroupAssignAuto({num:value,taskId:JSON.stringify(arr)},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '分配成功',
                                type: 'success'
                            });
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                });
            }
        },
        changeSum(){
            let sum=0;
            this.checkList.forEach(x=>{
                sum+=x.num;
            })
            this.yifenpei=sum
        },
        changeNum(i){
            this.checkList[i].num=0;
            
        },
        fenpei(){
            if(this.orderNum!=this.yifenpei){
                this.$message({
                    message: "请确保待分配数量为0",
                    type: 'warning'
                });
                return;
            }
            let arr=[];
            this.multipleSelection.forEach(x=>{
                arr.push(x.Id);
            });
            let list=[];
            this.checkList.forEach(x=>{
                if(x.num>0){
                    list.push(x)
                }
            });
            taskBatchAssign({
                json:JSON.stringify(list),
                taskId:JSON.stringify(arr),
            },(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '分配成功',
                        type: 'success'
                    });
                    this.query();
                    this.managerList.forEach( x=>{
                        this.checkList.push({
                            managerId:x.Id,
                            isCheck:false,
                            num:0
                        });
                    })
                    this.dialogVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        next(){
            if(this.orderNum==0||this.num==0){
                this.$message({
                    message: "请选择需要分配的任务",
                    type: 'warning'
                });
                return;
            }
            this.dialogVisible=true;
        },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.num=this.multipleSelection.length;
        let orderCount=0;
         this.multipleSelection.forEach(x=>{
             orderCount+=x.OrderCount;
         });
         this.orderNum=orderCount;
      },
        query(){
            this.isLoading=true;
            taskBatchGetExpected({},(res)=>{
                this.tableData=res.Result;
                setTimeout(() => {
                    this.isLoading=false;
                }, 100);
            })
        },

    }
}
</script>
<style scoped>
.row{
    margin-top:10px;
    margin-bottom: 10px;
}
</style>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>